import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

import TripUnitList from "./TripUnitList";

class TripUnitListWrapper extends Component {
  handleScrollTo(top) {
    const { scrollbars } = this.refs;

    if (scrollbars) scrollbars.scrollTop(top);
  }

  render() {
    return (
      <Scrollbars style={{ height: "100%" }} autoHide={true} ref="scrollbars">
        <TripUnitList handleScrollTo={this.handleScrollTo.bind(this)} />
      </Scrollbars>
    );
  }
}

export default React.memo(TripUnitListWrapper);
